module.exports = __webpack_public_path__ + "img/dsci0060.21332bbc.jpg";